<template>
  <div class="air-monitor-base-container">
    <MCard :title="$t('事件信息')" title-align="center">
      <MForm v-bind="formConfig" :model="formModel" />

      <MTable
        i18n-path="query"
        :loading="loading"
        :tableData="hisData"
        :tableColumn="tableColumn"
        :oprateMenu="oprateMenu"
        :pagiOption="pagiOption"
        height="calc(100% - 80px)"
        v-on:search="search"
      ></MTable>

      <el-dialog
        :append-to-body="true"
        :title="$t('进行处置')"
        :visible.sync="eventDisposalVisible"
        width="30%"
      >
        <eventModal v-bind="row" @closeDialog="closeDialogHandle" />
      </el-dialog>

      <el-dialog
        :append-to-body="true"
        :title="$t('提示')"
        :visible.sync="reportDialogVisible"
        width="30%"
      >
        <span>{{ $t('您确定要上报此事件么？') }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="reportDialogVisible = false">{{ $t('取消') }}</el-button>
          <el-button type="primary" @click="sureReportHandle">{{ $t('确定') }}</el-button>
        </span>
      </el-dialog>
    </MCard>
  </div>
</template>

<script>
import MTable from '@/components/mTable/m-table';
import MForm from '@/components/form/index.vue';
import MCard from '@/components/mCard/index.vue';
import eventModal from './components/event-modal.vue';
import { merge } from 'lodash';
import { convertArrayToObject, dayTime } from '@/utils/utils';
import { dictByCodeServer } from '@/api/dict';

import { eventListServer, saveEventServer } from '@/api/air-monitor/alarm-center';

let stateList;

export default {
  name: 'eventList',
  components: { MTable, MForm, MCard, eventModal },
  props: {
    sn: String,
    deviceType: String
  },
  computed: {
    comParams() {
      const { formModel, pagiOption } = this;

      let obj = merge(
        {
          beginTime: formModel.eventTime && formModel.eventTime[0],
          endTime: formModel.eventTime && formModel.eventTime[1],
          limit: pagiOption.limit,
          offset: pagiOption.offset
        },
        formModel
      );
      delete obj.eventTime;

      return obj;
    }
  },
  data() {
    stateList = [
      { value: 0, label: '未上报' },
      { value: 1, label: '已上报' },
      { value: 2, label: '待处置' },
      { value: 3, label: '已处置' }
    ];
    return {
      hisData: [],
      loading: false,
      formModel: {
        eventType: '',
        status: '',
        eventTime: [dayTime().begin.getTime(), dayTime().end.getTime()]
      },
      row: null,
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30, 100, 200],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      tableColumn: [
        { label: '事件类型', prop: 'showType' },
        { label: '时间', prop: 'eventTime' },
        { label: '状态', prop: 'showState' },
        { label: '处置建议', prop: 'disposeAdvice' },
        { label: '处置指令', prop: 'disposeInstruction' }
      ],
      oprateMenu: {
        label: '操作',
        list: [
          {
            text: '处置',
            access: () => {
              return true;
            },
            disabled: ({ row }) => row.status === '3',
            event: (_index, data) => {
              this.disposalHandle(data);
            }
          },
          {
            text: '上报',
            access: () => {
              return true;
            },
            disabled: ({ row }) => row.status === '1',
            event: (_index, data) => {
              this.reportHandle(data);
            }
          }
        ]
      },
      formConfig: {
        i18nPath: 'query',
        showClearable: true,
        config: {
          labelWidth: 'auto',
          span: 24,
          labelSuffix: ':',
          options: [
            {
              type: 'dateTimePicker',
              prop: 'eventTime',
              span: 8,
              label: this.$t('时间'),
              attrs: {
                type: 'datetimerange',
                valueFormat: 'timestamp'
              }
            },
            {
              type: 'select',
              prop: 'eventType',
              span: 4,
              dataKey: 'eventList',
              labelNeedTranslation: true,
              label: this.$t('事件类型')
            },
            {
              type: 'select',
              prop: 'status',
              dataKey: 'statusList',
              labelNeedTranslation: true,
              span: 4,
              label: this.$t('状态')
            }
          ],
          operation: {
            span: 6,
            buttons: [
              {
                text: '查询',
                loading: false,
                type: 'primary',
                handler: async ({ setLoading }) => {
                  setLoading(true);
                  await this.search();
                  setLoading(false);
                }
              }
            ]
          }
        },

        dataSource: {
          statusList: stateList,
          eventList: []
        },
        rules: {}
      },
      eventDisposalVisible: false,
      reportDialogVisible: false
    };
  },
  async mounted() {
    this.stateDict = {};
    this.eventDict = {};

    this.stateDict = convertArrayToObject(stateList);

    this.loadEventDictHandle();
  },
  methods: {
    langChangeHandler() {
      this.search();
    },
    loadEventDictHandle() {
      let eventOptions = [];
      dictByCodeServer('rf122_event_type').then(res => {
        res.data.forEach(item => {
          eventOptions.push({
            value: item.value,
            label: item.label
          });
        });
        this.formConfig.dataSource.eventList = eventOptions;
        this.eventDict = convertArrayToObject(res.data);
        this.search();
      });
    },
    search() {
      this.loading = true;

      eventListServer(this.comParams)
        .then(res => {
          //   res.data.list[0].status = 2;
          this.hisData = res.data.list;
          this.pagiOption.total = res.data.total;

          this.hisData.forEach(item => {
            item.showType = this.eventDict[item.eventType];
            item.showState = this.stateDict[item.status];
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    disposalHandle(row) {
      this.row = row;
      if (row.statue == 1) return;

      this.eventDisposalVisible = true;
    },
    reportHandle(row) {
      this.row = row;
      this.reportDialogVisible = true;
    },
    closeDialogHandle(e) {
      this.eventDisposalVisible = false;
      if (e) {
        this.search();
      }
    },
    sureReportHandle() {
      let obj = {
        id: this.row.id,
        status: '1'
      };
      saveEventServer(obj).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('上报成功'));
          this.reportDialogVisible = false;
          this.search();
        }
      });
    }
  }
};
</script>

<style lang="scss"></style>
